var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBakery = function SvgBakery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8a4 4 0 0 1 5.6-3.667A4.982 4.982 0 0 1 12 3c1.313 0 2.507.506 3.4 1.333A4 4 0 0 1 19.646 11H4.353A3.99 3.99 0 0 1 3 8Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 11 1.117 7.445A3 3 0 0 0 8.584 21H10m9.5-10-1.117 7.445A3 3 0 0 1 15.416 21H14m0 0h-4m4 0v-6m-4 6v-6",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBakery;